import { createStore } from 'vuex'
import api from '@/services/api'

export default createStore({
  state: {
    user: JSON.parse(localStorage.getItem('user') || sessionStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || sessionStorage.getItem('token') || null,
    showLoginModal: false
  },
  getters: {
    isAuthenticated: state => !!state.token,
    currentUser: state => state.user,
    userInitials: state => {
      if (!state.user || !state.user.name) return 'U'
      return state.user.name
        .split(' ')
        .map(n => n[0])
        .slice(0, 2)
        .join('')
        .toUpperCase()
    }
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
      // Auto-sync with whichever storage is currently holding the token
      if (localStorage.getItem('token')) {
        localStorage.setItem('user', JSON.stringify(user))
      } else if (sessionStorage.getItem('token')) {
        sessionStorage.setItem('user', JSON.stringify(user))
      }
    },
    SET_TOKEN(state, token) {
      state.token = token
      // Token persistence is usually handled by the login action specifically 
      // due to the rememberMe choice, but we keep the state in sync here.
    },
    TOGGLE_LOGIN_MODAL(state, show) {
      state.showLoginModal = show
    }
  },
  actions: {
    async login({ commit }, { email, password, rememberMe }) {
      try {
        const response = await api.post('/user/login', { email, password })
        const { token, user } = response.data

        commit('SET_TOKEN', token)
        commit('SET_USER', user)

        if (rememberMe) {
          localStorage.setItem('token', token)
          localStorage.setItem('user', JSON.stringify(user))
        } else {
          sessionStorage.setItem('token', token)
          sessionStorage.setItem('user', JSON.stringify(user))
        }

        return response
      } catch (error) {
        throw error
      }
    },
    logout({ commit }) {
      commit('SET_TOKEN', null)
      commit('SET_USER', null)

      localStorage.removeItem('token')
      localStorage.removeItem('user')
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('user')
    },
    async checkAuth({ commit, state }) {
      if (!state.token) return

      try {
        const response = await api.get('/user/profile')
        commit('SET_USER', response.data)
      } catch (error) {
        commit('SET_TOKEN', null)
        commit('SET_USER', null)

        localStorage.removeItem('token')
        localStorage.removeItem('user')
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('user')
      }
    }
  },
  modules: {
  }
})
